"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWrapper = exports.ButtonWrapper = exports.wrapperStyles = exports.VERSION_CONFIG = exports.LEVEL_CONFIG = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("../../../theme");
var Link_1 = __importDefault(require("../../navigation/Link"));
exports.LEVEL_CONFIG = {
    1: {
        small: {
            height: 50,
            padding: 28,
            borderWidth: 2,
        },
        medium: {
            height: 50,
            padding: 28,
            borderWidth: 2,
        },
        large: {
            height: 56,
            padding: 28,
            borderWidth: 2,
        },
    },
    2: {
        small: {
            height: 44,
            padding: 24,
            borderWidth: 2,
        },
        medium: {
            height: 44,
            padding: 24,
            borderWidth: 2,
        },
        large: {
            height: 48,
            padding: 24,
            borderWidth: 2,
        },
    },
    3: {
        small: {
            height: 32,
            padding: 16,
            borderWidth: 1,
        },
        medium: {
            height: 32,
            padding: 16,
            borderWidth: 1,
        },
        large: {
            height: 32,
            padding: 16,
            borderWidth: 1,
        },
    },
};
exports.VERSION_CONFIG = {
    filled: {
        normal: {
            backgroundColor: theme_1.theme.colors.BLUE_50,
            borderColor: theme_1.theme.colors.BLUE_50,
            color: theme_1.theme.colors.WHITE,
        },
        hover: {
            backgroundColor: theme_1.theme.colors.BLUE_60,
            borderColor: theme_1.theme.colors.BLUE_60,
            color: theme_1.theme.colors.WHITE,
        },
        disabled: {
            backgroundColor: theme_1.theme.colors.GREY_70,
            borderColor: theme_1.theme.colors.GREY_70,
            color: theme_1.theme.colors.WHITE,
        },
    },
    outline: {
        normal: {
            backgroundColor: 'transparent',
            borderColor: theme_1.theme.colors.BLUE_50,
            color: theme_1.theme.colors.BLUE_50,
        },
        hover: {
            backgroundColor: 'transparent',
            borderColor: theme_1.theme.colors.BLUE_60,
            color: theme_1.theme.colors.BLUE_60,
        },
        disabled: {
            backgroundColor: 'transparent',
            borderColor: theme_1.theme.colors.GREY_70,
            color: theme_1.theme.colors.GREY_70,
        },
    },
    'outline-filled': {
        normal: {
            backgroundColor: theme_1.theme.colors.WHITE,
            borderColor: theme_1.theme.colors.BLUE_50,
            color: theme_1.theme.colors.BLUE_50,
        },
        hover: {
            backgroundColor: theme_1.theme.colors.WHITE,
            borderColor: theme_1.theme.colors.BLUE_60,
            color: theme_1.theme.colors.BLUE_60,
        },
        disabled: {
            backgroundColor: theme_1.theme.colors.WHITE,
            borderColor: theme_1.theme.colors.GREY_70,
            color: theme_1.theme.colors.GREY_70,
        },
    },
};
exports.wrapperStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10000px;\n  border: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  cursor: pointer;\n\n  height: ", "px;\n  padding: ", ";\n\n  @media ", " {\n    border-width: ", ";\n    width: ", ";\n    height: ", "px;\n  }\n\n  @media ", " {\n    border-width: ", ";\n    width: ", ";\n    height: ", "px;\n  }\n\n  ", " {\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10000px;\n  border: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  cursor: pointer;\n\n  height: ", "px;\n  padding: ", ";\n\n  @media ", " {\n    border-width: ", ";\n    width: ", ";\n    height: ", "px;\n  }\n\n  @media ", " {\n    border-width: ", ";\n    width: ", ";\n    height: ", "px;\n  }\n\n  ", " {\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var _b = _a.$fullWidth, $fullWidth = _b === void 0 ? false : _b;
    return typeof $fullWidth === 'boolean'
        ? $fullWidth
            ? '100%'
            : 'auto'
        : ($fullWidth === null || $fullWidth === void 0 ? void 0 : $fullWidth.small)
            ? '100%'
            : 'auto';
}, function (_a) {
    var $version = _a.$version, disabled = _a.disabled;
    return exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'normal'].color;
}, function (_a) {
    var $version = _a.$version, disabled = _a.disabled;
    return exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'normal'].backgroundColor;
}, function (_a) {
    var $level = _a.$level, $version = _a.$version, disabled = _a.disabled;
    return "".concat(exports.LEVEL_CONFIG[$level].small.borderWidth, "px solid ").concat(exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'normal'].borderColor, "}");
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.3' : '1');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var $level = _a.$level;
    return exports.LEVEL_CONFIG[$level].small.height;
}, function (_a) {
    var $level = _a.$level;
    return "0 ".concat(exports.LEVEL_CONFIG[$level].small.padding, "px");
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $level = _a.$level;
    return "".concat(exports.LEVEL_CONFIG[$level].medium.borderWidth, "px");
}, function (_a) {
    var _b = _a.$fullWidth, $fullWidth = _b === void 0 ? false : _b;
    return typeof $fullWidth === 'boolean'
        ? $fullWidth
            ? '100%'
            : 'auto'
        : ($fullWidth === null || $fullWidth === void 0 ? void 0 : $fullWidth.medium)
            ? '100%'
            : 'auto';
}, function (_a) {
    var $level = _a.$level;
    return exports.LEVEL_CONFIG[$level].medium.height;
}, theme_1.theme.breakpoints.large, function (_a) {
    var $level = _a.$level;
    return "".concat(exports.LEVEL_CONFIG[$level].large.borderWidth, "px");
}, function (_a) {
    var _b = _a.$fullWidth, $fullWidth = _b === void 0 ? false : _b;
    return typeof $fullWidth === 'boolean'
        ? $fullWidth
            ? '100%'
            : 'auto'
        : ($fullWidth === null || $fullWidth === void 0 ? void 0 : $fullWidth.large)
            ? '100%'
            : 'auto';
}, function (_a) {
    var $level = _a.$level;
    return exports.LEVEL_CONFIG[$level].large.height;
}, theme_1.theme.utils.canHover, function (_a) {
    var $version = _a.$version, disabled = _a.disabled;
    return exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'hover'].color;
}, function (_a) {
    var $version = _a.$version, disabled = _a.disabled;
    return exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'hover'].backgroundColor;
}, function (_a) {
    var $version = _a.$version, disabled = _a.disabled;
    return exports.VERSION_CONFIG[$version][disabled ? 'disabled' : 'hover'].borderColor;
});
exports.ButtonWrapper = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.wrapperStyles);
exports.LinkWrapper = (0, styled_components_1.default)(Link_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.wrapperStyles);
var templateObject_1, templateObject_2, templateObject_3;
